import { render, staticRenderFns } from "./newConfig.vue?vue&type=template&id=11eb6324&scoped=true"
import script from "./newConfig.vue?vue&type=script&lang=js"
export * from "./newConfig.vue?vue&type=script&lang=js"
import style0 from "./newConfig.vue?vue&type=style&index=0&id=11eb6324&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eb6324",
  null
  
)

export default component.exports